export const SummaryLandingPageTemplate = {
    slots: ['SlbCheckoutContainerSlot'],
};